<script>
	import listBase from '@_system/components/base/list.vue'
	import goodsprice from './price/index.vue'
	import goodspull from './pull/index.vue'
	import footerIndex from './footer/index.vue'
	import goodstypetree from './goodstypetree/tree.vue'
	import goodsurlIndex from './goodsurl/index.vue'
	import XEClipboard from 'xe-clipboard'

	
	export default {
		extends: listBase,
		name: 'goodsIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-button size="mini" type="primary" style="margin-right:10px" onClick={this.synchronous}>同步类目</el-button>,
				<el-tag type="danger" size="mini">按含税价排序</el-tag>,
				<el-switch style="padding-left:20px" v-model={this.showUnsale} onChange={this.unsaleChange} active-text="显示不卖、原材料" inactive-text=""></el-switch>,
				<span style="padding-left:10px"><el-tag effect="dark" type="info" size="small">超过6个月</el-tag></span>,
				<span style="padding-left:10px"><el-tag effect="dark" type="" size="small">超过3个月</el-tag></span>,
				<span style="padding-left:10px"><el-tag effect="dark" type="success" size="small">3个月内</el-tag></span>,
				<span style="padding-left:10px"><el-tag effect="dark" type="danger" size="small">【新】3个月内有价格更新</el-tag></span>,
			]
			this.$slots.aside = [ <goodstypetree ref = "goodstypetree" key = {this.goodstypetreeKey} onSelect = {this.goodstypetreeChange}/>]
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index list={this} ref="footer" row={this.currentrow} />
				</div>
			]
			this.$slots.plug = [
				<vxe-table data={this.importsearchData} import-config={{}} style="display: none;" ref="importsearchTable">
					<vxe-column field="商品编码" title="商品编码"></vxe-column>
				</vxe-table>,
				<goodsprice ref="goodsprice" priceForm={this.priceForm} onSubmit={this.submitPrice} />,
				<goodsurlIndex data={this.goodsurldata} ref="goodsurlIndex" onSubmit={this.getgoodscodebygroupcode} />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				goodsUrl:null,
				goodsurldata:[],
				goodstypetreeKey:Math.random(),
				asideWidth: 200,
				showUnsale:false,
				loading: false,
				moduleName: 'goods',
				windowName: '商品',
				//windowType: 'window',
				exportIds: [],
				exportData: [],
				importsearchData: [],
				exportRef: Math.random(),
				noMap: ['a', 'b', 'c', 'd'],
				priceForm: {
					no: '',
					goodsid: 0,
					supplierid: 0,
					code: '',
					name: '',
					model: '',
					suppliername: '',
					price: '',
					row: null
				},
				pullForm: {
					date: Date.parse(new Date()),
					page: 1,
					limit: 100,
				},
				menuConfig: {
					body: {
						options: [
							[{
								code: 'copy',
								name: '复制',
								prefixIcon: 'vxe-icon-copy'
							}]
						]
					}
				},
				currentrow:null,
				currentType:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			distributionprice(){
				this.$refs.goodsprice.modal_show()
			},
			beforeCreateGrid(formConfig,columns){
				formConfig.items.unshift({
					field:'goodsurl',
					title:'商品链接',
					span:24,
					itemRender:{
						name:'$input',
						props:{
							placeholder:'输入商品链接 （商品链接查询优先级最高）',
							systemitem:true,
						}
					}				
				})	
				columns.forEach((item)=>{
					if (item.field.indexOf('supplierprice') !== -1 || item.field.indexOf('suppliertaxprice') !== -1) {
						item.slots = {
							default: ({row}) => {	
								let no = item.field.split('_')[1]
								if (row['priceupdatetime_' + no]) {
									let timestamp = new Date().getTime()/1000
									let priceupdatetime_diff = timestamp - row['priceupdatetime_' + no]
									let purchasestockbilltime_diff = timestamp - row['purchasestockbilltime_' + no]
									//小于3个月
									if( priceupdatetime_diff <= 7879680 && purchasestockbilltime_diff > 7879680){
										return [
											<el-tag size="mini" effect="dark" type="danger" style="margin-right:5px;">新</el-tag>,
											<span>{row[item.field]}</span>
										]
									}
								}
								return [<span>{row[item.field]}</span>]
							}
						}
					}
				})
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('supplierprice') !== -1 || column.property && column.property.indexOf('suppliertaxprice') !== -1) {
					let no = column.property.split('_')[1]
					if (row['purchasestockbill_' + no]) {
						let timestamp = new Date().getTime()/1000
						let diff = timestamp - row['purchasestockbilltime_' + no]
						//大于6个月
						if( diff >= 15759360){
							return {
								backgroundColor: '#C0C4CC',
								color: '#ffffff',
								fontSize:'18px'
							}
						}
						//大于3个月
						if( diff >= 7879680){
							return {
								backgroundColor: 'rgb(179, 216, 255)',
								fontSize:'18px'
							}
						}
						//大于0个月
						return {
							backgroundColor: 'rgb(225, 243, 216)',
							fontSize:'18px'
						}
					}else{
						return {
							fontSize:'18px'
						}
					}
				}
			},
			beforeRender(res){
				this.currentrow = null
				this.$refs.footer.inittab()
				if(res.goodsurl==1){
					this.goodsurldata = this.$Lodash.sortBy(res.goodsurldata, ['specValue']) 
					if(this.goodsurldata.length!=0){
						if(this.goodsurldata.length>1){
							this.$refs.goodsurlIndex.modal_show()
						}else{
							this.getgoodscodebygroupcode({code:this.goodsurldata[0].specCode})						
						}
						
					}else{
						this.$message.error('查询失败')
					}
				}
			},
			getgoodscodebygroupcode(e){
				this.loading = true
				this.$api.goods.getgoodscodebygroupcode({code:e.code}).then((res)=>{
					this.loading = false
					if(res.length!=0){
						this.$refs[this.moduleName + '_list'].commitProxy('query', {
							currentPage: -1,
							code: res.join(','),
							fromgoodsurl:1
						})
					}
				},()=>{
					this.loading = false
				})
			},
			cellClick({row}) {		
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.footer.inittab()
				})
			},
			contextMenuClickEvent({
				menu,
				row,
				column
			}) {
				let arr = [
					row.code,
					row.name,
					row.model,
					row.weight,
					row.supplierprice_a,
				]
				switch (menu.code) {
					case 'copy':
						if (row && column) {
							if (XEClipboard.copy(arr.join('	'))) {
								this.$message.success('已复制到剪贴板')
							}
						}
						break
				}
			},
			save(row) {
				let data = []
				let sort = []
				this.noMap.forEach((item) => {
					if (row['supplierid_' + item]) {
						data.push({
							goodsid: row.id,
							supplierid: row['supplierid_' + item],
							price1: row['supplierprice_' + item] ? row['supplierprice_' + item] : null,
						})
					}

					sort.push({
						supplierid: row['supplierid_' + item],
						suppliername: row['suppliername_' + item],
						suppliercode: row['suppliercode_' + item],
						price: row['supplierprice_' + item],
						priceorder: row['supplierprice_' + item] ? row['supplierprice_' + item] : 999999
					})


				})
				sort = sort.sort((a, b) => {
					return a.priceorder - b.priceorder
				})
				this.$api[this.moduleName].updatesupplierprice({
					data: data
				}).then(() => {
					this.$message.success('操作成功')
					this.noMap.forEach((item, index) => {
						if (sort[index]) {
							row['supplierid_' + item] = sort[index].supplierid
							row['suppliercode_' + item] = sort[index].suppliercode
							row['suppliername_' + item] = sort[index].suppliername
							row['supplierprice_' + item] = sort[index].price
						}
					})
				})
			},
			push() {
				this.$api[this.moduleName].push().then((res) => {
					if (res == 0) {
						this.$message.success('暂无可推送商品')
					} else {
						this.$message.success('成功推送 ' + res + ' 个商品')
					}

				})
			},
			pull() {
				this.$refs.goodspull.show = true
			},
			unsaleChange(e){
				this.foreingKey.unsale = e?1:0
				this.customreload()
			},
			goodstypetreeChange(e){
				this.foreingKey.goodstypeid = e.id
				this.currentType = e
				this.customreload()
			},
			synchronous(){
				if(!this.currentType){
					this.$message.error('请选择类目')
					return
				}
				//console.log(this.currentType)
				this.$refs.goodstypetree.loading = true
				this.$api.goods.grabCatagories({id:this.currentType.id}).then(()=>{
					this.goodstypetreeKey = Math.random()
					this.$refs.goodstypetree.loading = false
				},()=>{
					this.$refs.goodstypetree.loading = false
				})
			},
			submitPrice() {
				this.priceForm.row['supplierprice_' + this.priceForm.no] = this.priceForm.price

			},
			submitPull() {
				this.loading = true
				this.$api[this.moduleName].pull(this.pullForm).then((res) => {
					let str = ''
					str += '拉取商品数量：' + res.goodsNum + '\n'
					str += '拉取SKU数量：' + res.skuNum + '\n'
					str += '更新SKU数量：' + res.updateNum + '\n'
					str += '新增SKU数量：' + res.saveNum + '\n'
					if (res.goodsNum > this.pullForm.limit) {
						str += '\n' + '拉取未结束否继续？'
					} else {
						str += '\n' + '拉取结束'
					}
					let options = {
						width: 300,
						content: str,
						title: '拉取结果',
						status: 'success'
					}
					this.$VXETable.modal.confirm(options).then(type => {
						if (type == 'confirm' && res.goodsNum > this.pullForm.limit) {
							this.pullForm.page++
							this.$refs.goodspull.show = true
						}
					})

					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			tipcontentMethod({row,column}){
				if(column.property && (column.property.indexOf('supplierprice') !== -1 || column.property.indexOf('suppliertaxprice') !== -1)){
					let no = column.property.split('_')[1]
					let str = ''
					let priceupdatetime = window.systemMethods.timestampToDate(row['priceupdatetime_' + no],true)
					if (row['purchasestockbill_' + no]) {
						str += '最近采购单号：'+row['purchasestockbill_' + no] + '\n' 
						+ '最近采购时间：'+ window.systemMethods.timestampToDate(row['purchasestockbilltime_' + no],true) + '\n' 
					}
					
					return str += '是否含税：' + window.systemMethods.getEmunValue('enable',row['supplierhavetax_' + no]) + '\n' 
						+ '税点：' + row['suppliertaxpoint_' + no] + '%' + '\n' 
						+ '最近更新时间：' + (priceupdatetime?priceupdatetime:'无') + '\n' 
				}
			},
			afterexport(res) {
				let nomap = ['a', 'b', 'c', 'd']
				res.data.forEach((item) => {
					if (item['price1|name']) {
						let arr = item['price1|name'].split(',')
						arr.forEach((_item, index) => {
							//suppliername_a
							//supplierprice_a
							item['suppliername_' + nomap[index]] = _item
								.split(
									'|')[1]
							item['supplierprice_' + nomap[index]] = _item
								.split('|')[0]
						})
					}

				})

			},
			importsearch() {
				this.$refs.importsearchTable.reloadData([])
				this.$refs.importsearchTable.importData({
					type: 'xlsx',
					remote: false,
					afterImportMethod: (e) => {
						let data = e.$table.getTableData().fullData
						let code = []
						data.forEach((item, index) => {
							if (index != 0 && item['商品编码']) {
								code.push(item['商品编码'])
							}
						})
						this.$refs[this.moduleName + '_list'].commitProxy('query', {
							currentPage: -1,
							code: code.join(',')
						})

					}
				})
			},
			// importtemplate() {
			// 	this.$store.commit('getTemplate', 'goods')
			// },
			importsearchtemplate() {
				this.$store.commit('getTemplate', 'goodssearch')
			}
		},
		components: {
			goodsprice,
			goodspull,
			footerIndex,
			goodsurlIndex
		}
	}
</script>
